import { inject, observer } from "mobx-react";
import { computed } from "mobx";

import MainBlock from './MainBlock';
import QuickActions from './QuickActions';
import FaqBlock from './FaqBlock';

import './style.scss'


const MainPage = inject("mainStore")(
    observer(({ mainStore }) => {
        const auth = computed(() => mainStore.getMainStore("auth")).get()
        return (
            <div className="main-page">
                <MainBlock auth={auth} />
                <QuickActions />
                <FaqBlock />
            </div>
        );
    }),
);
export default MainPage;
